import { render, staticRenderFns } from "./form-edit.vue?vue&type=template&id=6624536b&scoped=true"
import script from "./form-edit.vue?vue&type=script&lang=js"
export * from "./form-edit.vue?vue&type=script&lang=js"
import style0 from "./form-edit.vue?vue&type=style&index=0&id=6624536b&prod&lang=css"
import style1 from "./form-edit.vue?vue&type=style&index=1&id=6624536b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624536b",
  null
  
)

export default component.exports